import { Pipe, PipeTransform } from '@angular/core';
import {LatLng} from './lat-lng';
import {LatLngModel} from '../models/lat.lng.model';

@Pipe({
    name: 'latLng',
    standalone: false
})
export class LatLngPipe implements PipeTransform {

  transform(latLng: LatLngModel): string;
  transform(latLng: LatLng | number[]);
  transform(value: any): any {
    if (!!value) {
      let latitude: number;
      let longitude: number;
      if (!!value.lat && !!value.lng) {
        latitude = value.lat;
        longitude = value.lng;
      } else if (Array.isArray(value) && value.length === 2) {
        longitude = value[0];
        latitude = value[1];
      }
      if (latitude && longitude) {
        const latChar = latitude > 0 ? 'N' : 'S';
        const lngChar = longitude < 0 ? 'W' : 'E';
        return `${latChar} ${latitude.toFixed(4)}, ${lngChar} ${longitude.toFixed(4)}`;
      }
    }
    return value;
  }

}
